<template>
  <a-modal width="50%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form"  :rules="rules">
      <a-alert
        type="warning"
        show-icon
        style="margin-bottom: 16px"
        message="当前未对接微信、支付宝商家转账，不会自动打款。请先线下手动打款，确认到账后再选择同意并审核通过。"
      />
      <a-form-model-item label="是否同意" prop="isPass" >
        <a-radio-group v-model="form.isPass" button-style="solid">
          <a-radio-button v-for="(item, index) in this.customDict.TFEnum" :value="item.type" :key="index">
            {{ item.name }}
          </a-radio-button>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item v-if="form.isPass" label="打款凭证"  prop="arriveImg" >
        <oss-upload-single v-model="form.arriveImg" prefix="merchant" type="img"/>
      </a-form-model-item>
      <a-form-model-item  v-if="form.isPass" label="打款备注"  prop="remark" >
        <a-input  v-model="form.remark" :maxLength="128"/>
      </a-form-model-item>
      <a-form-model-item v-if="!form.isPass" label="拒绝原因" prop="payFailMessage" >
        <a-textarea v-model="form.payFailMessage" :maxLength="200" :placeholder="$t('请输入')+'拒绝原因'" />
      </a-form-model-item>
      <a-modal :visible="previewImageVisible" :footer="null" @cancel="previewImageCancel">
        <img alt="example" style="width: 100%" :src="previewUrl" />
      </a-modal>
      <a-modal :visible="previewVideoVisible" :footer="null" @cancel="previewVideoCancel">
        <video style="width: 100%" :src="previewUrl" ref="myVideo"
               :poster="previewUrl + '?x-oss-process=video/snapshot,t_0,f_jpg'" :controls="true"></video>
      </a-modal>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitMarginForm">
            {{$t('确定')}}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{$t('取消')}}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-modal>
</template>

<script>
import {auditWithdrawApply, } from '@/api/user/withdraw'
import {mapGetters} from 'vuex'
import CustomDictTag from "@/components/DictCustomTag";
import OssUploadSingle from "@/components/OssUploadSingle/index.vue";


export default {
  name: 'AuditForm',
  props: {
  },
  components: {
    OssUploadSingle,
    CustomDictTag,
  },
  data () {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      previewImageVisible: false,
      previewUrl: '',
      previewVideoVisible: false,
      loading: '',
      record: {
        id:null,
      } ,
      errorMessage: null,
      // 表单参数
      form: {
        id: null,
        isPass:null,
        payFailMessage:null,
        remark: null,
        arriveImg: null,
      },
      formType: '',
      open: false,
      rules: {
        isPass: [
          { required: true, message: '是否同意'+this.$t('不能为空'), trigger: 'blur' }
        ],
        arriveImg: [
          { required: false, message: '截图'+this.$t('不能为空'), trigger: 'blur' }
        ],
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
      this.reset()
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    previewImageCancel() {
      this.previewImageVisible = false;
    },
    previewVideoCancel() {
      this.previewVideoVisible = false;
    },
    // 表单重置
    reset () {
      this.errorMessage = null,
      this.formType = 1
      this.record={
        id:null,
      }
      this.form = {
        id: null,
        isPass:true,
        payFailMessage:null,
        remark: null,
        arriveImg: null,
      }

    },
    /** 修改按钮操作 */
    handleAudit(id) {
      this.reset()
      this.form.id= id
      this.open = true
      this.formTitle = '提现打款审核';
    },
    /** 提交按钮 */
    submitMarginForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          let message= '审核成功'
          auditWithdrawApply(this.form).then(response => {
            if (response.code==='20001') {
              if (response.data) {
                message = response.data;
                this.errorMessage = message
                this.open = false;
                this.$emit('ok')
              }
              this.$message.success(
                message,
                3
              );
            }
          }).finally(() => {
            this.submitLoading = false
          })
        } else {
          return false
        }
      })
    },
  }
}
</script>
<style  lang="less" scoped>
.info-table {
  tr {
    height: 50px;
  }
  td {
    display: table-cell;
    vertical-align: top;
    font-size: 16px;
  }
  .first {
    width: 120px;
  }
  .data {
    width: 280px;
  }
}
</style>
